import { signOut } from "../../../app/actions";
import { AppDispatch } from "../../../app/store";
import { saveSessionId } from "./saveSessionId";

export const handleClientSideSignOut = (dispatch: AppDispatch) => {
  dispatch(signOut());
  saveSessionId(undefined, true);
  saveSessionId(undefined, false);
};
